import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MultiversxProvider } from "./multiversx-provider";
import { ConnectWalletProvider } from "./connect-wallet-provider";
import { SignTransactionProvider } from "./sign-transaction-provider";
import { SolanaWalletProvider } from "./solana-wallet-provider";
import { HeroUIProvider } from "@heroui/react";
import { Toaster } from "sonner";
import { BuyA1XModalProvider } from "../contexts/BuyA1XModalContext";
import { BuyA1XModal } from "../components/BuyA1X/BuyA1XModal";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <HeroUIProvider locale="en-GB" className="dark">
        <SolanaWalletProvider>
          <MultiversxProvider>
            <BuyA1XModalProvider>
              <ConnectWalletProvider />
              <SignTransactionProvider />
              {children}
              <BuyA1XModal />
              <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                  style: {
                    background: "#171717",
                    border: "1px solid #404040",
                    color: "#ffffff",
                  },
                }}
              />
            </BuyA1XModalProvider>
          </MultiversxProvider>
        </SolanaWalletProvider>
      </HeroUIProvider>
    </QueryClientProvider>
  );
};
